<template>
  <div class="icon">
    <template v-if="submission.materialList">
      <img :src="submission.materialList[0].playerUrl+'?imageMogr2/thumbnail/10000@'"
           v-if="submission.materialList[0].exif.type==1"></img>
      <template v-else-if="submission.materialList[0].exif.type==2">
        <img :src="submission.materialList[0].url+'?vframe/jpg/offset/1/w/100/h/100'"></img>
        <div class="video"></div>
      </template>
      <img src="https://assets.pfotoo.com/images/pc/text.png"
           v-else-if="submission.materialList[0].exif.type==3"></img>
      <img :src="'https://assets.pfotoo.com/file/' + submission.materialList[0].exif.mark + '.svg'"
           v-else-if="submission.materialList[0].exif.type==4"></img>
      <template v-else-if="submission.materialList[0].exif.type==5">
        <div class="audio-bg"></div>
        <img :src="submission.materialList[0].coverInfo.url+'?imageMogr2/thumbnail/10000@'" class="audio-img"></img>
      </template>
    </template>
  </div>
</template>

<script>
  export default {
    props:{
      submission:{
        type:Object,
        value:null
      },
    },
    data () {
      return {
        item:null,
      }
    },
    methods:{

    },
    mounted(){
      //this.init();
    }
  }
</script>

<style>
  .icon{
    width:20px;
    height:20px;
    position: relative;
  }
  .icon img{
    background-size: cover;
    background-position: center;
    width:20px;
    height:20px;
  }
  .video{
    position: absolute;
    background-size: cover;
    background-position: center;
    width:18px;
    height:18px;
    background-image: url("https://qn002.pfotoo.com/images/pc/play.png");
    top:1px;
    left: 1px;
  }
  .audio-bg{
    width: 20px;
    height: 20px;
    opacity: 1;
    background: linear-gradient(135deg,#d3eedf, #fbfdfd);
    border-radius: 1px;
    box-sizing: border-box;
  }
  .icon .audio-img{
    position: absolute;
    width: 16px;
    height: 16px;
    top:2px;
    left: 2px;
    border-radius: 50%;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/card/min.vue